<template>
  <q-form @submit="this.onSubmit" class="ms-form ms-form--narrow">
    <div class="ms-form-grid ms-form-grid--single">
      <CustomInput
          label="Название шага"
          :value="this.formData.step_name" :required="true"
          @change_input="(value) => onChange('step_name', value)"/>
      <CustomInput
          label="Код"
          :value="this.formData.step_code" :required="true"
          @change_input="(value) => onChange('step_code', value)"/>
      <CustomInput
          label="Комментарии" type="textarea" rows="4"
          :value="this.formData.comment"
          @change_input="(value) => onChange('comment', value)"/>
    </div>
    <CustomModalFooter :btn-loading="this.loading"/>
  </q-form>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "add-timeline-step",
  components: {CustomInput, CustomSelect, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      isFetching: false,
      formData: {
        step_name: this.data?.body?.step_name || '',
        step_code: this.data?.body?.step_code || '',
        comment: this.data?.body?.comment || '',
      },
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
}
</script>
